module.exports={
	"Form": "MixDesignEditManifest",
	"Scope": "MixDesign-Edit",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-Edit-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-Edit-Identity",
				"Group": "MixDesign-Edit-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-Edit-Identity",
				"Group": "MixDesign-Edit-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-Edit-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-Edit-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-Edit-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-Edit-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-Edit-Details",
				"Group": "MixDesign-Edit-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		},
		"MixDesignDetails.IDMixDesign":
		{
			"Name": "IDMix Design",
			"Hash": "MixDesign-Edit-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.GUIDMixDesign":
		{
			"Name": "GUIDMix Design",
			"Hash": "MixDesign-Edit-GUIDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixDesign-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixDesign-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixDesign-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		},
		"MixDesignDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixDesign-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-Edit-DataAudit",
				"Group": "MixDesign-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixDesign-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixDesign-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
